<template>
  <div class="details">
    <v-container fluid class="fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="10">

          <v-btn @click="checkUsers">CheckUsers</v-btn>
          <p>{{users.length}}</p>
          
          <v-card flat>
            <v-layout child-flex>
              <v-card class="pa-3 app_background" flat>
                <v-card-title>
                  <h1 class="subheading grey--text">Title</h1>
                </v-card-title>
                <v-card-title class="mt-5">
                  <h2 class="headline grey--text">Some text</h2>
                </v-card-title>
              </v-card>
            </v-layout>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { usersCollection } from '../plugins/firebase'

export default {
  name: "PostDetails",
  title: "PostDetails",

  data() {
    return {
      users: []
    };
  },
  methods: {

    // CHECK ALL VATICAN USERS AND SET THEM AS ISENTERPRISE (so they do not see pricing)
    async checkUsers(){

      const plansResults = await usersCollection
        .where("organizations", "array-contains", 'sASf57JDKA6jWcPCwfoA')
        // .where("email", "==", 'massimo.lavena@spc.va')
        .get();

      const plansInfo = [];

      await plansResults.forEach(async (doc) => {
        let singlePlan = doc.data();
        singlePlan.id = doc.id;
        plansInfo.push(singlePlan);

        await usersCollection
        .doc(doc.id)
        .set({ isEnterprise: true }, { merge: true });

        console.log('set email -> ' + singlePlan.email)
      });

      this.users = plansInfo

      // console.log('done')
    }
  }
};
</script>

<style scoped>
.start-button {
  max-width: 20px;
}
</style>